<template>
<div
    :class="{'chip-border': true, 'clickable': clickable, 'chip-error': error}"
    v-on:click="onClick"
>
    <v-icon
        class="chip-icon"
        size="28"
        :color="icon_color"
    >
        {{icon}}
    </v-icon>
    

    <div>
        <div
            :class="{'line-head' : true, 'light': light, 'text-error': error }"
        >
            {{line1}}
        </div>
        <div
            :class="{'line-primary': true, 'light': light, 'text-error': error}"
        >
            {{line2}}
        </div>
        <div
            :class="{'line-footer': true, 'light': light, 'text-error': error}"
        >
            {{line3}}
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: function() { return null; }
        },

        line1: {
            type: String,
            default: function() { return null; }
        },

        line2: {
            type: String,
            default: function() { return null; }
        },

        line3: {
            type: String,
            default: function() { return null; }
        },

        clickable: {
            type: Boolean,
            default: function() { return false; }
        },

        state: {
            type: String,
            default: function() { return 'regular'; }
        },
    },

    methods: {
        onClick() {
           if ( !this.clickable )
                return;

           this.$emit('click');     
        }
    },

    computed: {
        icon_color() {
            if ( this.light )
            {
                return 'grey lighten-2';
            }

            if ( this.error )
            {
                return 'red light-2';
            }

            return 'grey';
        },

        light() {
            return this.state == 'light';
        },

        error() {
            return this.state == 'error';
        },
    },
}
</script>

<style lang="scss" scoped>
.chip-icon
{
    padding-right: 10px;
}

.chip-border
{
    border: 1px solid rgba(0,0,0,0.1);
    background-color: rgba(0,0,0,0.025);
    border-radius: 5px;
    padding: 10px;

    max-width: 300px;
    min-width: 200px;

    display: flex;
}

.line-head,
.line-footer,
.line-primary
{
    margin-right: 10px;
}

.line-primary {
    font-size: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 210px;
}

.line-head
{
    font-size: 10px;
}

.line-footer
{
    font-size: 10px;
}

.clickable
{
    cursor: pointer;
}

.light
{
    color: rgba(0,0,0,0.4);
}
</style>